import { motion } from 'framer-motion';
import { RouletteWheel } from '../components/RouletteWheel';

export const RouletteBasics = () => {
  return (
    <section className="py-24 bg-charcoal-950 relative overflow-hidden">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 right-1/4 -translate-y-1/2 w-[600px] h-[600px] bg-gold-600/5 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-6 md:px-12 max-w-7xl relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-16 lg:gap-8">
          
          {/* Left Content - Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="w-full lg:w-1/2 flex flex-col items-start"
          >
            <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-gold-500/30 mb-8 backdrop-blur-sm bg-charcoal-900/50">
              <span className="text-gold-400 text-[10px] md:text-xs font-bold tracking-widest uppercase">THE BASICS</span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-10 tracking-wide uppercase">
              HOW ROULETTE WORKS
            </h2>
            
            <ul className="space-y-6 text-gray-300 text-base md:text-lg max-w-lg mb-12">
              <li className="flex items-start gap-4">
                <span className="w-2 h-2 rounded-full bg-[#d4af37] mt-2.5 flex-shrink-0 shadow-[0_0_8px_rgba(212,175,55,0.6)]" />
                <span className="leading-relaxed">A European Roulette wheel contains the numbers 0 through 36.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-2 h-2 rounded-full bg-[#d4af37] mt-2.5 flex-shrink-0 shadow-[0_0_8px_rgba(212,175,55,0.6)]" />
                <span className="leading-relaxed">Numbers are divided into red, black and a single green zero.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-2 h-2 rounded-full bg-[#d4af37] mt-2.5 flex-shrink-0 shadow-[0_0_8px_rgba(212,175,55,0.6)]" />
                <span className="leading-relaxed">Players can select individual numbers or betting groups such as colours, dozens or halves.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-2 h-2 rounded-full bg-[#d4af37] mt-2.5 flex-shrink-0 shadow-[0_0_8px_rgba(212,175,55,0.6)]" />
                <span className="leading-relaxed">The wheel determines the final result once the ball settles in a pocket.</span>
              </li>
              <li className="flex items-start gap-4">
                <span className="w-2 h-2 rounded-full bg-[#d4af37] mt-2.5 flex-shrink-0 shadow-[0_0_8px_rgba(212,175,55,0.6)]" />
                <span className="leading-relaxed">Each spin is independent — no previous result influences the next one.</span>
              </li>
            </ul>
            
            <div className="w-full max-w-lg bg-[#11131a] p-6 rounded-2xl border border-gray-800/80 shadow-lg">
              <p className="text-sm text-gray-400 leading-relaxed font-medium">
                Roulette is a game of chance. No system, pattern or strategy can guarantee a winning outcome.
              </p>
            </div>
          </motion.div>

          {/* Right Content - Wheel Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, ease: "easeOut" }}
            className="w-full lg:w-1/2 flex justify-center lg:justify-end"
          >
             <div className="relative w-full max-w-[500px] aspect-square">
                {/* Ensure the wheel scales nicely and doesn't capture clicks in this view */}
                <div className="w-full h-full pointer-events-none drop-shadow-2xl">
                   <RouletteWheel isSpinning={false} lastWinningNumber={null} isAmbient={true} />
                </div>
             </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};
